<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div>
                    <div class="text-center icon icon-shape bg-gradient-primary border-radius-2xl flex-row-reverse justify-content-between">
                      <i class="text-lg opacity-10 ni ni-money-coins" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">오늘 매출(TRX)</p>
                      <h5 class="font-weight-bolder">{{ comma(today_sales) }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div>
                    <div class="text-center icon icon-shape bg-gradient-danger border-radius-2xl flex-row-reverse justify-content-between">
                      <i class="text-lg opacity-10 ni ni-world" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">오늘 수당(TRX)</p>
                      <h5 class="font-weight-bolder">{{ comma(today_extra) }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div>
                    <div class="text-center icon icon-shape bg-gradient-success border-radius-2xl flex-row-reverse justify-content-between">
                      <i class="text-lg opacity-10 ni ni-paper-diploma" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">전송할 개수(TRX)</p>
                      <h5 class="font-weight-bolder">{{ comma(hold_trx) }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div>
                    <div class="text-center icon icon-shape bg-gradient-warning border-radius-2xl flex-row-reverse justify-content-between">
                      <i class="text-lg opacity-10 ni ni-cart" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">오늘 가입자</p>
                      <h5 class="font-weight-bolder">{{ comma(today_member) }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 mt-4">
          <div class="card card-plain border border-primary">
            <div class=" card-header text-start bg-gradient-primary">
              <h6 class="font-weight-bolder text-white">최근 매출/수당</h6>
            </div>
            <div class="card-body bg-white" style="border-bottom-left-radius: 1rem;border-bottom-right-radius: 1rem;">
              <div class="chart">
                <canvas id="chart-line" class="chart-canvas" height="300"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const CryptoJS = require("crypto-js");
import Chart from "chart.js/auto";
import { mapMutations } from "vuex";
export default {
  name: "dashboard-default",
  data() {
    return {
      today_sales : '0',
      today_extra : '0',
      hold_trx : '0',
      today_member : '0',
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,
      label : [],
      data : [],
      history:[],
    };
  },
  components: {

  },
  created(){
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
  },
  mounted() {
    if(this.$store.state.login){
      this.CheckTokenInfo();
      
      this.GetDashboardInfo();
      // this.DashboardDepoistList();
      // this.DashboardSalesChart();
    }else{
      this.$router.push({path:"/login"})
    }
    
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      } 
    }
  },
  methods:{
    CheckStatusClass(status){
      if(status =='H'){
        return "bg-gradient-warning";
      }else if(status =='Y'){
        return "bg-gradient-success";
      }else if(status =='C'){
        return "bg-gradient-danger";
      }else if(status =='P'){
        return "bg-gradient-primary";
      }
    },
    CheckStatus(status){
      if(status =='H'){
        return "대기중";
      }else if(status =='Y'){
        return "처리완료";
      }else if(status =='C'){
        return "취소";
      }else if(status =='P'){
        return "입금대기";
      }
    },
    
    comma(str) {
     str = String(str);
     return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    },
    uncomma(str) {
      str = String(str);
      return str.replace(/[^\d]+/g, '');
    },
    GetDashboardInfo(){
      this.axios.post('/admin/dashboard/GetDashboardInfo', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){

              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)

              this.today_sales = body.sales;
              this.today_extra = body.extra;
              this.hold_trx = body.hold_trx;
              this.today_member = body.member;

            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
      
    },
    
    DashboardSalesChart(){
      this.axios.post('/admin/dashboard/GetSalesChart', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){

              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)

              this.data = body.sdata;
              this.label = body.slabel;

              this.sdata = body.edata;

              this.CreateSalesChart();
              
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
      
    },
    ...mapMutations(["navbarMinimize"]),
    CheckTokenInfo(){
      this.axios.post('/admin/common/CheckTokenInfo', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CreateSalesChart : function(){
      var ctx1 = document.getElementById("chart-line").getContext("2d");

      new Chart(ctx1, {
        type: "line",
        data: {
          labels: this.label,
          datasets: [
            {
              label: "매출 금액",
              tension: 0.4,
              borderWidth: 0,
              pointRadius: 0,
              borderColor: "#F08080",
              backgroundColor: "#F08080",
              // eslint-disable-next-line no-dupe-keys
              borderWidth: 3,
              fill: false,
              data: this.data,
              maxBarThickness: 6,
            },
            {
              label: "지급 금액",
              tension: 0.4,
              borderWidth: 0,
              pointRadius: 0,
              borderColor: "#8080F0",
              backgroundColor: "#8080F0",
              // eslint-disable-next-line no-dupe-keys
              borderWidth: 3,
              fill: false,
              data: this.sdata,
              maxBarThickness: 6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#fbfbfb",
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                color: "#ccc",
                padding: 20,
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
          },
        },
      });
    },
  }
};
</script>
